
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from '@/components/ui/sidebar';
import {
  LayoutDashboard,
  Settings,
  FileText,
  MessageSquareQuote,
  Users,
  Home,
  LogOut,
  CheckCircle
} from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export const AdminSidebar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={window.location.pathname === '/admin'}>
          <Link to="/admin">
            <LayoutDashboard className="mr-2 h-4 w-4" />
            <span>Dashboard</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={window.location.pathname === '/admin/peo'}>
          <Link to="/admin/peo">
            <Settings className="mr-2 h-4 w-4" />
            <span>PEO</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={window.location.pathname === '/admin/verifications'}>
          <Link to="/admin/verifications">
            <CheckCircle className="mr-2 h-4 w-4" />
            <span>PEO Verifications</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={window.location.pathname === '/admin/applications'}>
          <Link to="/admin/applications">
            <FileText className="mr-2 h-4 w-4" />
            <span>Applications</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={window.location.pathname === '/admin/quotes'}>
          <Link to="/admin/quotes">
            <MessageSquareQuote className="mr-2 h-4 w-4" />
            <span>Quotes</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={window.location.pathname === '/'}>
          <Link to="/">
            <Home className="mr-2 h-4 w-4" />
            <span>Main Site</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton onClick={handleLogout}>
          <LogOut className="mr-2 h-4 w-4" />
          <span>Logout</span>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
